// @flow
import type {LoginParams} from 'modules/Authenticate/types/index'

export const buildDigestHeader = (params: LoginParams) => {
  let result = 'DigestLeapXpert '
  const keys = Object.keys(params)
  keys.map((key, index) => {
    if (params[key]) {
      if (index < keys.length - 1) {
        result += `${key}="${params[key]}",`
      } else {
        result += `${key}="${params[key]}"`
      }
    }
    return null
  })
  return result
}

// $FlowFixMe
export const parseDigestHeader = (header: string): LoginParams => {
  const result = {}
  if (!header) return result
  const headerString = header.replace('DigestLeapXpert ', '')
  headerString.split(',').map(param => {
    const key = param.split('=')[0]
    const value = param.split('=')[1].replace(/"/g, '')
    result[key] = value
    return null
  })
  return result
}
